var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9616 3.33251C17.8858 3.32471 17.8095 3.32471 17.7338 3.33251H2.17823C2.07854 3.33405 1.9795 3.349 1.88379 3.37696L9.91157 11.3714L17.9616 3.33251Z",
    fill: "#230050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7831 4.10596L10.6942 12.1615C10.4861 12.3685 10.2045 12.4846 9.91091 12.4846C9.61737 12.4846 9.33576 12.3685 9.12758 12.1615L1.11091 4.16707C1.08627 4.25765 1.0732 4.35098 1.07202 4.44485V15.556C1.07202 15.8506 1.18908 16.1333 1.39746 16.3416C1.60583 16.55 1.88845 16.6671 2.18313 16.6671H17.7387C18.0334 16.6671 18.316 16.55 18.5244 16.3416C18.7327 16.1333 18.8498 15.8506 18.8498 15.556V4.44485C18.8454 4.3291 18.8229 4.21475 18.7831 4.10596ZM2.94424 15.556H2.17202V14.7615L6.21091 10.756L6.99424 11.5393L2.94424 15.556ZM17.7276 15.556H16.9498L12.8998 11.5393L13.6831 10.756L17.722 14.7615L17.7276 15.556Z",
    fill: "#230050"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b5b43b5ac2b244f016a3d5d7dc92f1a2.svg";
export { ForwardRef as ReactComponent };